<style lang="stylus">

    .print-container {
        display: flex;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: var(--bg-color-primary);
        z-index: 99;
        overflow: hidden;

        .print-container-title {
            position: absolute;
            top: 0;
            width: 100%;
            height: 32px;
            background: var(--bg-color-print-container-title);
            color: var(--text-color-print-container-title);
            line-height: 32px;
            font-size: 14px;
            padding: 0 30px;
            display: flex;
            align-items: center;

            > svg {
                width: 20px;
                height: 20px;
                margin-right: 6px;
                stroke: var(--svg-color-primary);
            }

            .title-close {
                position: absolute;
                top: 4px;
                right: 5px;
                width: 25px;
                height: 25px;
                cursor: pointer;
                border-radius: $common-border-radius;

                &:hover {
                    background-color: $common-hover-color;
                }

                > svg {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: var(--svg-color-gray-42)
                    width: 17px;
                    height: 17px;
                }
            }
        }

        .print-inner {
            display: flex;
            position: absolute;
            left: 0;
            right: 0;
            top: 32px;
            bottom: 0;
            background: var(--bg-color-primary);
            z-index: 10;
        }

        .print-container-left {
            overflow: hidden;
            position: relative;
            flex: 1;
            background: var(--bg-color-print-container-left);
           .noVipTips-box{
                max-width: 100%;
                width: 288px;
                height: 32px;
                padding: 0 15px;
                position: absolute;
                z-index: 1;
                top: 16px;
                left: 0;
                right: 0;
                margin: auto;
                background: linear-gradient(267.65deg, #FFDBA6 9.41%, #FFF5C6 90.77%);
                border-radius: 32px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                &:hover{
                    background: linear-gradient(267.65deg, #FFCD83 9.41%, #FFEBA6 90.77%);
                }
                .vip-icon{
                    margin-right: 8px;
                    width: 16px;
                    height: 16px;
                }
                span{
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 14px;
                    color: #4B2603;
                }
            }
            .print-content {
                position: absolute;
                top: 57px;
                bottom: 114px;
                left: 0px;
                right: 0px;
                overflow: auto;
                // padding: 30px;
                box-sizing: border-box;
                // display: flex;
                // justify-content: center;
                // align-items: center;

                .print-page-item-wrapper {
                    margin: auto;

                    canvas {
                        float: left;
                        box-shadow: 4px 6px 24px rgba(0, 0, 0, 0.16);
                    }
                }
                &::-webkit-scrollbar {
                    height: 6px;
                    width: 6px;
                }
            }

            .print-page-bottom {
                left: 50%;
                border-radius: $common-border-radius;
                transform: translate(-50%);
                position: absolute;
                height: 50px;
                bottom: 48px;
                background: var(--bg-color-print-container-bottom);
                display: flex;
                width 810px;
                max-width: 810px;
                padding: 0 28px
                display: flex;
                justify-content: space-between;
                box-shadow var(--box-print-container-bottom)
                .print-page-bottom-paging {
                    display: flex;
                    align-items: center;
                    position: absolute;
                    left: 50%
                    top: 50%
                    transform:translate(-50%,-50%);
                    .print-page-bottom-pre {
                        width: 22px;
                        height: 22px;
                        border-radius: 50%;
                        cursor: pointer;
                        text-align: center;
                        line-height: 20px;
                        font-size: 15px;
                        margin: 0 30px;
                        opacity: 0.7;
                        transition: all 0.3s;
                        user-select: none;
                        svg {
                            width 7px;
                            height 12px;
                            color var(--svg-color-primary);
                        }
                        &:hover {
                            opacity: 1;
                        }
                    }

                    .print-page-bottom-active {
                        width: 34px;
                        height: 22px;
                        text-align: center;
                        line-height: 20px;
                        border: 1px solid $box-bordercolor;
                        border-radius: 3px;
                        margin-right: 14px;
                        font-size: 14px;
                    }

                    .print-page-bottom-text {
                        font-size: 14px;
                        height: 22px;
                        line-height: 20px;
                    }

                    .print-page-bottom-all {
                        line-height 22px;
                        text-align: center;
                        width: 34px;
                        margin-left: 10px
                        background-color: var(--bg-color-print-page-bottom-view);
                        border-radius: $box-radius;
                        font-size: 14px;
                        height: 22px;
                    }
                }
                .print-page-bottom-view-left {
                    display: flex;
                    align-items: center;

                    .print-page-bottom-view-item {
                        background-color: var(--bg-color-print-page-bottom-view)
                        width: 24px;
                        height: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-repeat: no-repeat;
                        background-position: center;
                        transition: all 0.3s;
                        cursor: pointer;
                        svg {
                            height 16px;
                            width 16px;
                            color var(--svg-color-primary)
                        }
                        &.singleResize,&.pageResize{
                          border-radius: $box-radius 0 0 $box-radius;
                          margin-right: 2px
                        }
                        &.allResize,&.pageResizeWidth{
                          border-radius:0 $box-radius $box-radius 0;
                          margin-right: 20px
                        }

                        &:hover {
                            background-color: var(--bg-color-print-page-bottom-view-hover);
                            svg {
                                color: var(--svg-color-active)
                            }
                        }
                    }
                }
                .print-page-bottom-view {
                    height: 100%;
                    display: flex;



                    .print-page-bottom-view-right {
                        display: flex;
                        align-items: center;
                        margin-left: 50px;
                    }

                    .zoom-icon {
                        stroke: var(--svg-color-primary);
                        user-select: none;

                        &:hover {
                            stroke: var(--svg-color-primary);
                        }
                        width: 12px;
                        height: 12px;
                        cursor: pointer;
                    }

                    .zoom-input {
                        width: 100px;
                        margin: 0 5px;
                        -webkit-appearance: none;
                        border-radius: 2px;
                        height: 3px;
                        background: var(--bg-color-print-page-bottom-zoom-input);
                        outline: none;
                        transition: 0.1s;
                        background-image: linear-gradient(var(--text-color-primary),var(--text-color-primary));
                        background-size: 50% 100%;
                        background-repeat: no-repeat;

                        &::-webkit-slider-thumb {
                            -webkit-appearance: none;
                            width: 8px;
                            height: 8px;
                            background: var(--bg-color-zoom-slider-thumb);
                            border-radius: 50%;
                            border: 2px solid var(--border-color-zoom-slider);
                            transition: 0.1s;
                            cursor: pointer;
                        }

                        &:hover::-webkit-slider-thumb,
                        &:active::-webkit-slider-thumb {
                            width: 12px;
                            height: 12px;
                        }
                    }

                    .zoom-value {
                        margin-left: 5px;
                        user-select: none;
                        color: var(--text-color-black);
                    }
                }
            }
        }

        .print-container-right {
            width: 280px;
            background: var(--bg-color-primary);
            max-height: 100%;
            overflow: visible;

            .print-container-right-inner {
                padding: 0 13px;
            }

            .print-setting-btn {
                margin-bottom: 20px;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;

                .print-btn {
                    position: relative;
                }

                >div {
                    padding: 5px 0px;
                    border-radius: 4px;
                    font-size: 13px;
                    cursor: pointer;
                    width: 112px;
                    height: 28px
                    text-align: center;
                    transition: all .2s;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: var(--box-shadow-color-small);
                    border: 1px solid var(--border-color-gray-10);
                    &:nth-child(2) {
                        margin-left: 16px;
                    }

                    &:nth-child(1) {
                        border: 1px solid var(--themeColor);
                        background: var(--themeColor);
                        color: #fff;
                        &:hover{
                          background-color: var(--themeColor);
                        }
                    }

                    &:hover {
                        background: var(--themeColor);
                        border: 1px solid var(--themeColor);
                        color: #fff;
                    }
                }
            }

            .print-options {
                font-weight: 600;
                font-size: 13px;
                margin-top: 16px;
            }

            .print-options-print {
                margin-top: 20px;
                margin-bottom: 6px;

                .print-options-gridbox {
                    // padding-left: 12px;
                    margin-top: 12px;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;

                    > label {
                        margin: 10px 0;
                    }

                    .ivu-checkbox-wrapper {
                        font-size: 13px;
                    }

                    .print-options-checkbox {
                        width: 50%;
                        margin: 10px 0;
                        label{
                            width: 100%;
                            display: flex;
                            align-items: center;
                        }
                        .text{
                            display: inline-block;
                            max-width: calc(100% - 14px - 32px);
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            vertical-align: middle;
                            margin-left: 4px;
                        }
                    }
                }
            }

            .print-options-box {
                div {
                    font-size: 13px;
                }

                .print-options-item {
                    margin-top: 20px;
                    margin-bottom: 6px;
                    display: flex;
                    // white-space: nowrap;
                    justify-content: space-between;
                    align-items: center;
                }
            }

            .print-options-title {
                font-size: 13px;
                min-width: 40%;
            }

            .print-options-select {
                > div {
                    > div {
                        display: flex;
                        max-width: 140px;

                        div:nth-child(n+3) {
                            display: none;
                        }
                    }
                }
            }
            .ivu-select-multiple{
                .ivu-select-item-focus{
                    background: transparent;
                }
            }

            .print-options-item-rate {
                margin-bottom: 20px;
                display: flex;
                white-space: nowrap;
                align-items: center;
                justify-content: space-between;

                .print-options-item-rate-label {
                    min-width: 80px;
                    margin-right: 16px;

                    .ivu-radio-wrapper {
                        font-size: 13px
                    }
                }
            }

            .print-options-item-fit {
                margin-bottom: 20px;
                display: flex;
                white-space: nowrap;
                justify-content: space-between;

                .print-options-item-rate-label {
                    min-width: 80px;
                    margin-right: 16px;
                }

                .fit-inp {
                    margin-bottom: 8px;
                }
            }

            .print-view {
                width: 100%;
                height: 160px;
                // background: #a8a8a8;
                // border: 1px solid #dedede;
                margin: 10px auto;
                display: flex;
                justify-content: center;
                align-items: center;

                #printView {
                    border-radius: $box-radius;
                }

                .print-view-page {
                    width: 300px;
                    height: 260px;
                    background-position: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .print-view-draw {
                        width: 200px;
                        height: 160px;
                        background: #74a3fb;
                        border: 2px solid #fff;
                    }
                }
            }

            .print-view-des {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;
                font-size: 13px;
                > div {
                    display: flex;
                    align-items: center;
                    &:nth-child(1) {
                        width: 35%;
                    }

                    &:nth-child(2) {
                        width: 65%;
                    }

                    .text {
                        width: calc(100% - 30px);
                        margin-left: 8px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                .print-view-des-icon {
                    width: 30px;
                    height: 16px;
                    border: 1px solid #888;
                }
            }
        }

        .ivu-tag {
            border: none !important;
            background-color: var(--bg-color-ivu-tag)!important;
            .ivu-tag-text {
                color: var(--text-color-primary)!important;
            }
            .ivu-icon-ios-close {
                color: var(--icon-color-ivu-close-primary)!important;
            }
        }

        .ivu-select-selection {
            border-radius: $common-border-radius!important
            border: 1px solid $box-bordercolor!important;
            background-color var(--bg-color-tertiary)
            color var(--text-color-primary)
            border 1px solid var(--border-color-box-6)
            border-radius 6px !important
        }
        .ivu-input-number-disabled{
            background: var(--bg-color-ivu-input-disabled) !important;
            border: 1px solid var(--border-color-ivu-input-disabled)!important;
            border-radius: 6px!important;
        }
    }
</style>
<i18n>
{
    "zh": {
        "updateVip": "升级VIP会员",
        "printTips": "支持打印无水印的文件！",
        "selectplz": "请选择",
        "printSet": "打印设置",
        "printOption": "打印选项",
        "docPage": "文档页",
        "pageSize": "页面尺寸",
        "pageDir": "页面方向",
        "allSel": "全选",
        "print": "打印",
        "cancel": "取消",
        "grid": "网格",
        "guideLine": "参考线",
        "note": "注释",
        "Centered": "居中打印",
        "watermark": "水印",
        "printScale": "打印比例缩放",
        "resizeTo": "调整为",
        "suitTo": "适应到",
        "printPreview": "纸张对比",
        "printPaper": "打印纸",
        "drawPage": "绘图页",
        "singleResize": "单页适应到绘图",
        "allResize": "所有页适应到绘图",
        "pageResize": "页面适应到绘图",
        "pageResizeWidth": "页面适应到绘图宽度",
        "landscape": "横向",
        "portrait": "纵向",
        "pageSize1": "信纸",
        "pageSize2": "Tabloid",
        "pageSize3": "法律专用纸",
        "pageSize4": "Statement",
        "pageSize5": "Executive",
        "pageSize6": "A3",
        "pageSize7": "A4",
        "pageSize8": "A5",
        "pageSize9": "B4(JIS)",
        "pageSize10": "B5(JIS)"
    },
    "en": {
        "updateVip": "Upgrade now",
        "printTips": " to print without watermark!",
        "selectplz": "Please select",
        "printSet": "Print Settings",
        "printOption": "Print Options",
        "docPage": "Pages",
        "pageSize": "Page Size",
        "pageDir": "Orientation",
        "allSel": "All pages",
        "print": "Print",
        "cancel": "Cancel",
        "grid": "Grid",
        "guideLine": "Guideline",
        "note": "Note",
        "Centered": "Centered",
        "watermark": "Watermark",
        "printScale": "Scaling",
        "resizeTo": "Adjust to",
        "suitTo": "Fit to",
        "printPreview": "Paper Contrast",
        "printPaper": "Print Paper",
        "drawPage": "Drawing Page",
        "singleResize": "Resize single page to fit the drawing's dimensions.",
        "allResize": "Resize all pages to fit the drawing's dimensions",
        "pageResize": "Resize page to fit the drawing's dimensions",
        "pageResizeWidth": "Resize the page to fit the width of drawing's dimensions",
        "landscape": "Landscapge",
        "portrait": "Portrait",
        "pageSize1": "Letter",
        "pageSize2": "Tabloid",
        "pageSize3": "Legal",
        "pageSize4": "Statement",
        "pageSize5": "Executive",
        "pageSize6": "A3",
        "pageSize7": "A4",
        "pageSize8": "A5",
        "pageSize9": "B4(JIS)",
        "pageSize10": "B5(JIS)"
    },
    "jp": {
        "updateVip": "アップグレード",
        "printTips": "すると、透かしなしで印刷できます！",
        "selectplz": "選択してください",
        "printSet": "印刷設定",
        "printOption": "印刷オプション",
        "docPage": "ページ",
        "pageSize": "ページサイズ",
        "pageDir": "向き",
        "allSel": "すべて選択",
        "print": "印刷",
        "cancel": "キャンセル",
        "grid": "グリッド",
        "guideLine": "ガイドライン",
        "note": "注釈",
        "Centered": "センタープリント",
        "watermark": "透かし",
        "printScale": "カスタム倍率",
        "resizeTo": "自動調整",
        "suitTo": "合わせる",
        "printPreview": "印刷プレビュー",
        "printPaper": "印刷用紙",
        "drawPage": "図面ページ",
        "singleResize": "単一ページを図面に合わせる",
        "allResize": "すべてのページを図面に合わせる",
        "pageResize": "ページを図面に合わせる",
        "pageResizeWidth": "ページを図面の幅に合わせる",
        "landscape": "横",
        "portrait": "縦",
        "pageSize1": "便箋",
        "pageSize2": "Tabloid",
        "pageSize3": "法律専用紙",
        "pageSize4": "Statement",
        "pageSize5": "Executive",
        "pageSize6": "A3",
        "pageSize7": "A4",
        "pageSize8": "A5",
        "pageSize9": "B4(JIS)",
        "pageSize10": "B5(JIS)"
    },
    "fr": {
        "updateVip": "Mettre à niveau maintenant",
        "printTips": " pour imprimer sans filigrane !",
        "selectplz": "Veuillez Sélectionner",
        "printSet": "Paramètres d'impression",
        "printOption": "Options d'impression",
        "docPage": "Page de Documentation",
        "pageSize": "Taille de Page",
        "pageDir": "Orientation de Page",
        "allSel": "Tout Sélectionner",
        "print": "Imprimer",
        "cancel": "Annuler",
        "grid": "Grille",
        "guideLine": "Ligne Directrice",
        "note": "Note",
        "Centered": "Impression centrale",
        "watermark": "Filigrane",
        "printScale": "Mise à l'échelle de l'impression",
        "resizeTo": "Ajuster à",
        "suitTo": "Adapter à",
        "printPreview": "Contraste papier",
        "printPaper": "Papier d'impression",
        "drawPage": "Page de dessin",
        "singleResize": "Redimensionner une seule page pour l'adapter aux dimensions du dessin.",
        "allResize": "Redimensionner toutes les pages pour qu'elles correspondent aux dimensions du dessin",
        "pageResize": "Redimensionner la page pour l'adapter aux dimensions du dessin",
        "pageResizeWidth": "Redimensionner la page pour l'adapter à la largeur des dimensions du dessin",
        "landscape": "Horizontal",
        "portrait": "Vertical",
        "pageSize1": "Lettre",
        "pageSize2": "Tabloïde",
        "pageSize3": "Papier Juridique",
        "pageSize4": "Déclaration",
        "pageSize5": "Exécutive",
        "pageSize6": "A3",
        "pageSize7": "A4",
        "pageSize8": "A5",
        "pageSize9": "B4(JIS)",
        "pageSize10": "B5(JIS)"
    },
    "de": {
        "updateVip": "Jetzt upgraden",
        "printTips": ", um ohne Wasserzeichen zu drucken!",
        "selectplz": "Bitte auswählen",
        "printSet": "Druckeinstellungen",
        "printOption": "Druckoptionen",
        "docPage": "Seite",
        "pageSize": "Seitengröße",
        "pageDir": "Orientierung",
        "allSel": "Alle Seiten",
        "print": "Drucken",
        "cancel": "Abbrechen",
        "grid": "Gitter ",
        "guideLine": "Anleitung",
        "note": "Notiz",
        "Centered": "Mitteldruck",
        "watermark": "Wasserzeichen",
        "printScale": "Skalierung",
        "resizeTo": "Anpassen an ",
        "suitTo": "Entsprechen",
        "printPreview": "Papierkontrast",
        "printPaper": "Druckpapier",
        "drawPage": "Seite zeichnen",
        "singleResize": "Ändern Sie die Größe einer einzelnen Seite, um sie den Abmessungen der Zeichnung anzupassen.",
        "allResize": "Passen Sie die Größe aller Seiten an die Abmessungen der Zeichnung an",
        "pageResize": "Größe der Seite an die Abmessungen der Zeichnung anpassen",
        "pageResizeWidth": "Ändern Sie die Größe der Seite, um sie an die Breite der Zeichnungsabmessungen anzupassen",
        "landscape": "Breitformat",
        "portrait": "Hochformat",
        "pageSize1": "Blatt",
        "pageSize2": "Tabloid",
        "pageSize3": "Legal",
        "pageSize4": "Statement",
        "pageSize5": "Executive",
        "pageSize6": "A3",
        "pageSize7": "A4",
        "pageSize8": "A5",
        "pageSize9": "B4(JIS)",
        "pageSize10": "B5(JIS)"
    },
    "es": {
        "updateVip": "Actualiza ahora",
        "printTips": " para imprimir sin marca de agua!",
        "selectplz": "Por favor, seleccione",
        "printSet": "Configuraciones de impresión",
        "printOption": "Opciones de impresión",
        "docPage": "Páginas",
        "pageSize": "Tamaño de la página",
        "pageDir": "Orientación",
        "allSel": "Todas las páginas",
        "print": "Imprimir",
        "cancel": "Cancelar",
        "grid": "Rejilla",
        "guideLine": "Guía",
        "note": "Nota",
        "Centered": "Impresión central",
        "watermark": "Marca de agua",
        "printScale": "Escala",
        "resizeTo": "Ajustar a",
        "suitTo": "Adaptado a",
        "printPreview": "Contraste del papel",
        "printPaper": "Papel de impresión",
        "drawPage": "Página de dibujo",
        "singleResize": "Redimensionar una sola página para que se ajuste a las dimensiones del dibujo",
        "allResize": "Redimensionar todas las páginas para que se ajusten a las dimensiones del dibujo",
        "pageResize": "Redimensionar la página para que se ajuste a las dimensiones del dibujo",
        "pageResizeWidth": "Redimensionar la página para que se ajuste al ancho de las dimensiones del dibujo",
        "landscape": "Paisaje",
        "portrait": "Retrato",
        "pageSize1": "Carta",
        "pageSize2": "Tabloid",
        "pageSize3": "Legal",
        "pageSize4": "Declaración",
        "pageSize5": "Ejecutivo",
        "pageSize6": "A3",
        "pageSize7": "A4",
        "pageSize8": "A5",
        "pageSize9": "B4(JIS)",
        "pageSize10": "B5(JIS)"
    },
    "pt": {
        "updateVip": "Atualize agora",
        "printTips": " para imprimir sem marca d'água!",
        "selectplz": "Por favor, selecionar",
        "printSet": "Configurações de Impressão",
        "printOption": "Opções de Impressão",
        "docPage": "Páginas",
        "pageSize": "Tamanho da Página",
        "pageDir": "Orientação",
        "allSel": "Todas as páginas",
        "print": "Imprimir",
        "cancel": "Cancelar",
        "grid": "Grelha",
        "guideLine": "Orientação",
        "note": "Nota",
        "Centered": "Impressão central",
        "watermark": "Marca de Água",
        "printScale": "Dimensionamento",
        "resizeTo": "Regular a",
        "suitTo": "Ajustar a",
        "printPreview": "Contraste de Papel",
        "printPaper": "Papel de Impressão",
        "drawPage": "Desenho de Página",
        "singleResize": "Redimensionar página única para ajustar às dimensões do desenho.",
        "allResize": "Redimensionar todas as páginas para ajustar às dimensões do desenho",
        "pageResize": "Redimensionar página para ajustar às dimensões do desenho",
        "pageResizeWidth": "Redimensionar a página para ajustar a largura às dimensões do desenho",
        "landscape": "Paisagem",
        "portrait": "Retrato",
        "pageSize1": "Carta",
        "pageSize2": "Tablóide",
        "pageSize3": "Legal",
        "pageSize4": "Declaração",
        "pageSize5": "Executivo",
        "pageSize6": "A3",
        "pageSize7": "A4",
        "pageSize8": "A5",
        "pageSize9": "B4(JIS)",
        "pageSize10": "B5(JIS)"
    },
    "it": {
        "updateVip": "Aggiorna ora",
        "printTips": " per stampare senza filigrana!",
        "selectplz": "Si prega di selezionare",
        "printSet": "Impostazioni di Stampa",
        "printOption": "Opzioni di Stampa",
        "docPage": "Pagine",
        "pageSize": "Dimensione Pagina",
        "pageDir": "Orientamento",
        "allSel": "Tutte le Pagine",
        "print": "Stampa",
        "cancel": "Annulla",
        "grid": "Griglia",
        "guideLine": "Linee Guida",
        "note": "Nota",
        "Centered": "Stampa centrale",
        "watermark": "Filigrana",
        "printScale": "Scala",
        "resizeTo": "Ridimensiona",
        "suitTo": "Adatta a",
        "printPreview": "Anteprima di Stampa",
        "printPaper": "Carta Stampata",
        "drawPage": "Pagina del Disegno",
        "singleResize": "Ridimensiona una singola pagina per adattarla alle dimensioni del disegno.",
        "allResize": "Ridimensiona tutte le pagine per adattarle alle dimensioni del disegno.",
        "pageResize": "Ridimensiona la pagina per adattarla alle dimensioni del disegno.",
        "pageResizeWidth": "Ridimensiona la pagina per adattarla alla larghezza del disegno.",
        "landscape": "Orizzontale",
        "portrait": "Verticale",
        "pageSize1": "Lettera",
        "pageSize2": "Tabloid",
        "pageSize3": "Legale",
        "pageSize4": "Rendiconto",
        "pageSize5": "Executive",
        "pageSize6": "A3",
        "pageSize7": "A4",
        "pageSize8": "A5",
        "pageSize9": "B4(JIS)",
        "pageSize10": "B5(JIS)"
    },
    "tw": {
        "updateVip": "立即升級",
        "printTips": "以移除打印浮水印！",
        "selectplz": "請選擇",
        "printSet": "列印設置",
        "printOption": "列印選項",
        "docPage": "檔案頁",
        "pageSize": "頁面尺寸",
        "pageDir": "頁面方向",
        "allSel": "全選",
        "print": "列印",
        "cancel": "取消",
        "grid": "網格",
        "guideLine": "參考線",
        "note": "注釋",
        "Centered": "居中打印",
        "watermark": "水印",
        "printScale": "列印比例縮放",
        "resizeTo": "調整為",
        "suitTo": "適應到",
        "printPreview": "紙張對比",
        "printPaper": "打印紙",
        "drawPage": "繪圖頁",
        "singleResize": "單頁適合到繪圖",
        "allResize": "所有頁適合到繪圖",
        "pageResize": "頁面適合到繪圖",
        "pageResizeWidth": "頁面適合到繪圖寬度",
        "landscape": "橫向",
        "portrait": "縱向",
        "pageSize1": "信紙",
        "pageSize2": "Tabloid",
        "pageSize3": "法律專用紙",
        "pageSize4": "Statement",
        "pageSize5": "Executive",
        "pageSize6": "A3",
        "pageSize7": "A4",
        "pageSize8": "A5",
        "pageSize9": "B4(JIS)",
        "pageSize10": "B5(JIS)"
    },
    "kr": {
        "updateVip": "지금 업그레이드하고",
        "printTips": " 워터마크 없이 프린트하기!",
        "selectplz": "선택하세요",
        "printSet": "인쇄 설정",
        "printOption": "인쇄 옵션",
        "docPage": "문서 페이지",
        "pageSize": "페이지 크기",
        "pageDir": "페이지 방향",
        "allSel": "전부 선택",
        "print": "인쇄",
        "cancel": "취소",
        "grid": "격자무늬",
        "guideLine": "가이드라인",
        "note": "주석",
        "Centered": "중간 인쇄",
        "watermark": "워터마크",
        "printScale": "인쇄 비율 크기 조정",
        "resizeTo": "로 조정",
        "suitTo": "에 맞음",
        "printPreview": "종이 대비",
        "printPaper": "인쇄용지",
        "drawPage": "제도 페이지",
        "singleResize": "단일 페이지가 그래픽에 적응",
        "allResize": "모든 페이지가 그래픽에 적응",
        "pageResize": "그래픽 치수에 맞게 페이지 크기 조정",
        "pageResizeWidth": "그래픽 치수 너비에 맞게 페이지 크기 조정",
        "landscape": "가로",
        "portrait": "세로",
        "pageSize1": "편지지",
        "pageSize2": "Tabloid",
        "pageSize3": "법률전용용지",
        "pageSize4": "Statement",
        "pageSize5": "Executive",
        "pageSize6": "A3",
        "pageSize7": "A4",
        "pageSize8": "A5",
        "pageSize9": "B4(JIS)",
        "pageSize10": "B5(JIS)"
    }
}
</i18n>
<template>
    <div class="print-container">
        <div class="print-container-title">
            <iconSymbol :name="'printTitleIcon'" />
            {{ $t("printSet") }}
            <div class="title-close" @click="close()" @mousedown.stop>
                <iconSymbol name="Del" />
            </div>
        </div>
        <div class="print-inner">
            <div class="print-container-left" ref="canvasArea">
                <div v-if="!vip" class="noVipTips-box" @click="toVip">
                    <VipIcon />
                    <span :title="$t('updateVip') + $t('printTips')">{{ $t("updateVip") }}{{ $t("printTips") }}</span>
                </div>
                <div class="print-content">
                    <div
                        class="print-page-item-wrapper"
                        v-for="(item, index) in pageList"
                        :key="index"
                        v-show="activePage == index && page.length > 0"
                        :style="{
                            height: getWrapperHeight(),
                            width: getWrapperWidth(),
                            marginTop: getMarginTop(),
                        }"
                    >
                        <canvas
                            v-for="(canvas, index) in item.canvasList"
                            :key="index"
                            :ref="'printCanvas_' + item._id + '_' + index"
                            class="canvas"
                            :style="{
                                width: (pageWidth * zoomValue) / 100 + 'px',
                                height: (pageHeight * zoomValue) / 100 + 'px',
                                margin: (44 * zoomValue) / 100 + 'px',
                            }"
                        ></canvas>
                        <!-- <div class="print-page-item" :class="'print_page_item_' + index">

                        </div> -->
                    </div>
                </div>
                <div class="print-page-bottom" v-show="page.length > 0">
                    <div class="print-page-bottom-view-left">
                        <div class="print-page-bottom-view-item singleResize" :title="$t('singleResize')" @click="viewFit(1)">
                            <iconSymbol name="print-view-1" />
                        </div>
                        <div class="print-page-bottom-view-item allResize" :title="$t('allResize')" @click="viewFit(2)">
                            <iconSymbol name="print-view-2" />
                        </div>
                        <div class="print-page-bottom-view-item pageResize" :title="$t('pageResize')" @click="viewFit(3)">
                            <iconSymbol name="print-view-3" />
                        </div>
                        <div class="print-page-bottom-view-item pageResizeWidth" :title="$t('pageResizeWidth')" @click="viewFit(4)">
                            <iconSymbol name="print-view-4" />
                        </div>
                    </div>

                    <div class="print-page-bottom-paging">
                        <div class="print-page-bottom-pre" @click="pagePre()">
                            <iconSymbol name="print-arrow-left" />
                        </div>
                        <div class="print-page-bottom-active">{{ activePage + 1 }}</div>
                        <div class="print-page-bottom-text">/</div>
                        <div class="print-page-bottom-all">{{ pageList.length }}</div>
                        <div class="print-page-bottom-pre" @click="pageNext()">
                            <iconSymbol name="print-arrow-right" />
                        </div>
                    </div>
                    <div class="print-page-bottom-view">
                        <div class="print-page-bottom-view-right">
                            <iconSymbol class="zoom-icon" :name="'minusRound'" @click.native="zoomDowns" />
                            <input
                                class="zoom-input"
                                type="range"
                                min="10"
                                max="200"
                                step="1"
                                v-model="zoomValue"
                                ref="zoomInput"
                                @change="zoomChange($event)"
                                @input="inputRange"
                            />
                            <iconSymbol class="zoom-icon" :name="'plusRound'" @click.native="zoomUps" />
                            <div class="zoom-value">{{ zoomValue }}%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="print-container-right">
                <div class="print-setting-btn" v-show="page.length > 0">
                    <div @click="print" class="print-btn">
                        {{ $t("print") }}
                    </div>
                    <div @click="close">{{ $t("cancel") }}</div>
                </div>
                <div class="print-container-right-inner">
                    <div class="print-options">{{ $t("printOption") }}</div>
                    <div class="print-options-box">
                        <div class="print-options-item">
                            <div class="print-options-title">{{ $t("docPage") }}</div>
                            <i-select
                                v-model="page"
                                :placeholder="$t('selectplz')"
                                :multiple="true"
                                @on-change="pageChange()"
                                size="small"
                                style="flex: 1"
                                class="print-options-select"
                            >
                                <i-option value="all" v-if="pageList.length > 1">{{ $t("allSel") }}</i-option>
                                <i-option v-for="item in pageList" :value="item._id" :key="item._id">{{ item._name }}</i-option>
                            </i-select>
                            <!-- <Button size="small" style="margin: 0 12px" @click="pageSelectAll()">全选</Button>
                            <Button size="small" @click="pageClearAll()">清空</Button> -->
                        </div>

                        <div class="print-options-item" v-show="page.length > 0">
                            <div class="print-options-title">{{ $t("pageSize") }}</div>
                            <i-select v-model="size" @on-change="pageSize" size="small">
                                <i-option v-for="item in sizeList" :value="item.value" :key="item.value">
                                    {{ `${$t(item.label)} (${item.width} x ${item.height} ${item.unit == 9 ? "mm" : "in"})` }}
                                </i-option>
                            </i-select>
                        </div>

                        <div class="print-options-item" v-show="page.length > 0">
                            <div class="print-options-title">{{ $t("pageDir") }}</div>
                            <i-select v-model="format" @on-change="pageFormat()" size="small" style="width: 80px">
                                <i-option v-for="item in formatList" :value="item.value" :key="item.value">{{ item.label }}</i-option>
                            </i-select>
                        </div>

                        <!-- <div class="print-options-item">
                            <div class="print-options-title">页面缩放</div>
                            <i-select v-model="scale" @on-change="pageScale()">
                                <i-option v-for="item in scaleList" :value="item.value" :key="item.value">{{ item.label }}</i-option>
                            </i-select>
                        </div> -->
                        <div class="print-options-print" v-show="page.length > 0">
                            <div class="print-options">{{ $t("print") }}</div>
                            <Checkbox-group v-model="printList" class="print-options-gridbox" @on-change="showGrid">
                                <div class="print-options-checkbox">
                                    <Checkbox label="grid">
                                        <span class="text" :title="$t('grid')">{{ $t("grid") }}</span>
                                    </Checkbox>
                                </div>
                                <div class="print-options-checkbox">
                                    <Checkbox label="guide">
                                        <span class="text" :title="$t('guideLine')">{{ $t("guideLine") }}</span>
                                    </Checkbox>
                                </div>
                                <div class="print-options-checkbox">
                                    <Checkbox label="note">
                                        <span class="text" :title="$t('note')">{{ $t("note") }}</span>
                                    </Checkbox>
                                </div>
                                <div class="print-options-checkbox">
                                    <Checkbox label="Centered">
                                        <span class="text" :title="$t('Centered')">{{ $t("Centered") }}</span>
                                    </Checkbox>
                                </div>
                                <div class="print-options-checkbox">
                                    <Checkbox label="watermark">
                                        <span class="text" :title="$t('watermark')">{{ $t("watermark") }}</span>
                                        <VipIcon v-if="!vip" />
                                    </Checkbox>
                                </div>
                            </Checkbox-group>
                        </div>
                    </div>
                    <div class="print-options" v-show="page.length > 0">{{ $t("printScale") }}</div>
                    <div class="print-options-box" v-show="page.length > 0">
                        <div class="print-options-item">
                            <Radio-group v-model="fitList" style="width: 100%" @on-change="fitChange">
                                <div class="print-options-item-rate">
                                    <div class="print-options-item-rate-label">
                                        <Radio label="fit_1">{{ $t("resizeTo") }}</Radio>
                                    </div>
                                    <i-select
                                        v-model="scale"
                                        @on-change="pageScale()"
                                        :disabled="!fitList.includes('fit_1')"
                                        size="small"
                                        style="width: 80px"
                                    >
                                        <i-option v-for="item in scaleList" :value="item.value" :key="item.value">
                                            {{ item.label }}
                                        </i-option>
                                    </i-select>
                                </div>
                                <div class="print-options-item-fit">
                                    <div class="print-options-item-rate-label">
                                        <Radio label="fit_2">{{ $t("suitTo") }}</Radio>
                                    </div>
                                    <div>
                                        <div class="fit-inp">
                                            <Input-number
                                                :max="50"
                                                :min="1"
                                                v-model="xSheet"
                                                size="small"
                                                :disabled="!fitList.includes('fit_2')"
                                                @on-change="xsheetChange"
                                                @on-blur="xsheetBlur"
                                            ></Input-number>
                                            <!-- &nbsp&nbsp  页数 -->
                                        </div>
                                        <div class="fit-inp">
                                            <Input-number
                                                :max="50"
                                                :min="1"
                                                v-model="ySheet"
                                                size="small"
                                                :disabled="!fitList.includes('fit_2')"
                                                @on-change="ysheetChange"
                                                @on-blur="ysheetBlur"
                                            ></Input-number>
                                            <!-- &nbsp&nbsp  页数 -->
                                        </div>
                                    </div>
                                </div>
                            </Radio-group>
                        </div>
                        <div class="print-options">{{ $t("printPreview") }}</div>
                    </div>
                    <div class="print-view" v-show="page.length > 0">
                        <!-- <div class="print-view-page" :style="{backgroundImage: `url(${require('@/app/assets/img/print/bg.svg')})`}">
                            <div class="print-view-draw">

                            </div>
                        </div> -->
                        <canvas id="printView"></canvas>
                    </div>
                    <div class="print-view-des" v-show="page.length > 0">
                        <div>
                            <div class="print-view-des-icon" :style="{ backgroundImage: `url(${require('@/app/assets/img/print/bg.svg')})` }"></div>
                            <span :title="$t('printPaper')" class="text">{{ $t("printPaper") }}</span>
                        </div>
                        <div>
                            {{ sizeList[size].label }}, {{ sizeList[size].width }}x{{ sizeList[size].height }}
                            {{ sizeList[size].unit == 9 ? "mm" : "in" }}
                        </div>
                    </div>
                    <div class="print-view-des" v-show="page.length > 0">
                        <div>
                            <div class="print-view-des-icon" :style="{ background: isDarkTheme() ? '#1f1f1f' : '#fff' }"></div>
                            <span :title="$t('drawPage')" class="text">{{ $t("drawPage") }}</span>
                        </div>
                        <div v-if="pageList[activePage]">
                            {{ preDefinedPaper }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    declare var eDrawFlag: any;
    declare var UnitUtil: any;
    declare var eUnit: any;
    declare var blobStream: any;
    // declare var PDFDocument: any;
    declare var s_prePapers: any;
    declare var EDPaint: any;
    declare var EDColor: any;
    declare var ePaintType: any;
    declare var egRect: any;
    declare var EDView: any;
    declare var ExportWaterMark: any;
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    const PDFDocument = require("@/app/utils/pdfkit.min.js");

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {},
    })
    export default class Base extends Vue {
        @Inject()
        ["checkVipLimit"];
        // pageList = []
        activePage = 0;
        page = [];
        format = "landscape";
        formatList = [
            {
                value: "landscape",
                label: "landscape",
            },
            {
                value: "portrait",
                label: "portrait",
            },
        ];
        scale = 100;
        scaleList = [
            {
                value: 400,
                label: "400%",
            },
            {
                value: 200,
                label: "200%",
            },
            {
                value: 150,
                label: "150%",
            },
            {
                value: 100,
                label: "100%",
            },
            {
                value: 75,
                label: "75%",
            },
            {
                value: 50,
                label: "50%",
            },
            {
                value: 25,
                label: "25%",
            },
        ];
        size = 6;
        sizeList = [
            {
                value: 0,
                label: "pageSize1",
                width: 8.5,
                height: 11,
                unit: eUnit.in,
            },
            {
                value: 1,
                label: "pageSize2",
                width: 11,
                height: 17,
                unit: eUnit.in,
            },
            {
                value: 2,
                label: "pageSize3",
                width: 8.5,
                height: 14,
                unit: eUnit.in,
            },
            {
                value: 3,
                label: "pageSize4",
                width: 5.5,
                height: 8.5,
                unit: eUnit.in,
            },
            {
                value: 4,
                label: "pageSize5",
                width: 7.25,
                height: 10.5,
                unit: eUnit.in,
            },
            {
                value: 5,
                label: "pageSize6",
                width: 297,
                height: 420,
                unit: eUnit.mm,
            },
            {
                value: 6,
                label: "pageSize7",
                width: 210,
                height: 297,
                unit: eUnit.mm,
            },
            {
                value: 7,
                label: "pageSize8",
                width: 148,
                height: 210,
                unit: eUnit.mm,
            },
            {
                value: 8,
                label: "pageSize9",
                width: 257,
                height: 364,
                unit: eUnit.mm,
            },
            {
                value: 9,
                label: "pageSize10",
                width: 182,
                height: 257,
                unit: eUnit.mm,
            },
        ];
        pageWidth = 0;
        pageHeight = 0;
        fitList = "fit_1";
        xSheet = 1;
        ySheet = 1;
        printList = [];
        zoomValue = 100;
        preDefinedPaper = "";
        canvasList = [];
        viewFitType = null;
        showWatermark = true;

        //生命周期
        mounted() {
            let doc = window["_view"]._doc;
            let pageSize = this.sizeList[this.size];
            this.pageWidth = UnitUtil.unitToPixel(pageSize.height, pageSize.unit);
            this.pageHeight = UnitUtil.unitToPixel(pageSize.width, pageSize.unit);
            // this.pageList = doc._pages
            console.log(doc._pages);
            // 获取用户最后一次是否选中水印
            if (this.customPreferContent && this.customPreferContent["defaultIsShowWatermark"] === false) {
                this.showWatermark = false;
            } else {
                this.showWatermark = true;
            }
            this.page = [window["_view"]._activePage._id];
            this.pageList.forEach((item, index) => {
                if (item._id == window["_view"]._activePage._id) {
                    this.activePage = index;
                }
            });
            this.setpaper();
            this.$nextTick(() => {
                this.drawPreview();
            });

            this.drawPrintView();

            this.formatList = [
                {
                    value: "landscape",
                    label: this.$t("landscape").toString(),
                },
                {
                    value: "portrait",
                    label: this.$t("portrait").toString(),
                },
            ];
            (this.$refs.canvasArea as any).addEventListener("DOMMouseScroll", this.zoomFunc, { passive: false }); //firefox;
            (this.$refs.canvasArea as any).addEventListener("wheel", this.zoomFunc, { passive: false }); //IE/Opera/Chrome/Safari
        }

        created() {}

        toVip() {
            this.$openBuyPage("printNomark");
        }

        zoomFunc(e: WheelEvent) {
            // Ctrl 滚轮缩放事件
            // Mac 触控板双指方向不一致时，ctrlKey为 true
            let ctrlkey = EDView.osInfo.platform === "Mac" ? e.metaKey || e.ctrlKey : e.ctrlKey;
            if (ctrlkey) {
                if (e["wheelDelta"]) {
                    //IE/Opera/Chrome
                    if (e["wheelDelta"] > 0) {
                        this.zoomUps();
                    } else {
                        this.zoomDowns();
                    }
                    e.preventDefault();
                } else if (e.detail) {
                    //Firefox
                    if (e.detail < 0) {
                        this.zoomUps();
                    } else {
                        this.zoomDowns();
                    }
                    e.preventDefault();
                }
            }
        }

        get pageList() {
            let doc = window["_view"]._doc;
            return doc._pages;
        }

        drawPrintView() {
            let canvas = <HTMLCanvasElement>document.querySelector("#printView");
            let isDarkTheme = this.isDarkTheme();
            let ctx = canvas.getContext("2d");
            let view = window["_view"];
            let printConfig = this.pageList[this.activePage]._printConfig;
            let page = this.pageList[this.activePage];
            if (!view) return;
            let width = 224,
                height = 156;
            let m_hSheet = 1;
            let m_vSheet = 1;
            let m_paperOrienIdx = 0;
            let m_paperWidth = 0;
            let m_paperHeight = 0;
            let m_pageWidth = 0;
            let m_pageHeight = 0;
            let m_zoom = 1;
            let m_adjustMode = true;
            let offsetW = 20,
                offsetH = 0;
            canvas.width = width;
            canvas.height = height;
            ctx.fillStyle = isDarkTheme ? "#333" : "#f1f1f2";
            ctx.strokeStyle = "rgb(160, 160, 160)";
            ctx.lineWidth = 0.5;
            ctx.translate(0.5, 0.5);
            ctx.fillRect(0, 0, width, height);
            ctx.stroke();

            if (page._isPortrait) {
                m_paperWidth = UnitUtil.unitToPixel(printConfig._paperWidth, printConfig._paperUnit);
                m_paperHeight = UnitUtil.unitToPixel(printConfig._paperHeight, printConfig._paperUnit);
            } else {
                m_paperHeight = UnitUtil.unitToPixel(printConfig._paperWidth, printConfig._paperUnit);
                m_paperWidth = UnitUtil.unitToPixel(printConfig._paperHeight, printConfig._paperUnit);
            }
            m_pageWidth = page._width.real();
            m_pageHeight = page._height.real();
            m_hSheet = printConfig._xSheet;
            m_vSheet = printConfig._ySheet;

            if (!printConfig._fitTo) {
                let pw = (m_pageWidth * this.scale) / 100;
                let ph = (m_pageHeight * this.scale) / 100;

                let col = Math.round(pw / m_paperWidth + 0.49);
                let row = Math.round(ph / m_paperHeight + 0.49);

                let mw = Math.max(pw, m_paperWidth * col);
                let mh = Math.max(ph, m_paperHeight * row);

                let rate = Math.min((width - offsetW) / mw, (height - offsetH) / mh);
                let pageDrawW = pw * rate;
                let pageDrawH = ph * rate;
                let paperDrawW = m_paperWidth * rate;
                let paperDrawH = m_paperHeight * rate;

                let startX = Math.round((width - paperDrawW * col) * 0.5);
                let startY = Math.round((height - paperDrawH * row) * 0.5);

                if (Math.abs(paperDrawW * col - pageDrawW) > 3 || Math.abs(paperDrawH * row - pageDrawH) > 3) {
                    ctx.fillStyle = isDarkTheme ? "#1f1f1f" : "rgb(255, 255, 255)";
                    ctx.fillRect(startX, startY, paperDrawW * col, paperDrawH * row);

                    let edpaint = new EDPaint();
                    let edcolor = new EDColor();
                    edcolor._color = 0x3498db;
                    let edcolor2 = new EDColor();
                    edcolor2._color = 0xffffff;
                    edpaint._colors = [edcolor, edcolor2];
                    edpaint._index = 12;
                    edpaint._type = ePaintType.Hatch;
                    let path = new egRect(startX, startY, paperDrawW * col, paperDrawH * row).toPath();
                    edpaint.draw(ctx, null, null, null, false, path);
                }
                ctx.beginPath();
                ctx.fillStyle = isDarkTheme ? "#1f1f1f" : "rgb(255, 255, 255)";

                ctx.strokeStyle = "rgb(160, 160, 160)";

                ctx.rect(startX, startY, pageDrawW, pageDrawH);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();
                ctx.setLineDash([5, 5]);

                if (col == 1 && row == 1) {
                    if (pageDrawW - paperDrawW > 1) {
                        ctx.beginPath();
                        ctx.strokeStyle = "rgb(160, 160, 160)";
                        ctx.moveTo(startX + paperDrawW, startY + 1);
                        ctx.lineTo(startX + paperDrawW, startY + pageDrawH - 1);
                        ctx.stroke();
                        ctx.closePath();
                    }
                    if (pageDrawH - paperDrawH > 1) {
                        ctx.beginPath();
                        ctx.strokeStyle = "rgb(160, 160, 160)";

                        ctx.moveTo(startX + 1, startY + paperDrawH);
                        ctx.lineTo(startX + pageDrawW - 1, startY + paperDrawH);
                        ctx.stroke();
                        ctx.closePath();
                    }
                } else {
                    for (let i = 1; i < col; i++) {
                        ctx.beginPath();
                        ctx.strokeStyle = "rgb(160, 160, 160)";

                        ctx.moveTo(startX + i * paperDrawW, startY + 1);
                        ctx.lineTo(startX + i * paperDrawW, startY + pageDrawH - 1);
                        ctx.stroke();
                        ctx.closePath();
                    }

                    for (let j = 1; j < row; j++) {
                        ctx.beginPath();
                        ctx.strokeStyle = "rgb(160, 160, 160)";
                        ctx.moveTo(startX + 1, startY + j * paperDrawH);
                        ctx.lineTo(startX + pageDrawW - 1, startY + j * paperDrawH);
                        ctx.stroke();
                        ctx.closePath();
                    }
                    ctx.setLineDash([]);
                    ctx.strokeStyle = "rgb(160, 160, 160)";
                    for (let i = 1; i < col; i++) {
                        if (paperDrawW * col > pageDrawW) {
                            ctx.beginPath();

                            ctx.moveTo(startX + paperDrawW * i, startY + pageDrawH);
                            ctx.lineTo(startX + paperDrawW * i, startY + paperDrawH * row - 1);
                            ctx.stroke();
                            ctx.closePath();
                        }
                    }
                    for (let j = 1; j < row; j++) {
                        if (paperDrawH * row > pageDrawH) {
                            ctx.beginPath();

                            ctx.moveTo(startX + pageDrawW, startY + paperDrawH * j);
                            ctx.lineTo(startX + paperDrawW * col - 1, startY + paperDrawH * j);
                            ctx.stroke();
                            ctx.closePath();
                        }
                    }
                }

                // ctx.closePath()
                // 折角
                if (Math.abs(paperDrawW * col - pageDrawW) <= 3 && Math.abs(paperDrawH * row - pageDrawH) <= 3) {
                    let edpaint = new EDPaint();
                    let edcolor = new EDColor();
                    edcolor._color = 0x3498db;
                    let edcolor2 = new EDColor();
                    edcolor2._color = 0xffffff;
                    edpaint._colors = [edcolor, edcolor2];
                    edpaint._index = 12;
                    edpaint._type = ePaintType.Hatch;
                    let path = new egRect(startX + 1, startY + 1, 22, 22).toPath();
                    edpaint.draw(ctx, null, null, null, false, path);

                    ctx.beginPath();
                    ctx.setLineDash([5, 5]);
                    ctx.moveTo(startX + 1, startY + 23);
                    ctx.lineTo(startX + 23, startY + 1);
                    ctx.stroke();
                    ctx.closePath();

                    ctx.beginPath();
                    ctx.setLineDash([]);
                    ctx.moveTo(startX + 1, startY + 23);
                    ctx.lineTo(startX + 23, startY + 23);
                    ctx.moveTo(startX + 23, startY + 1);
                    ctx.lineTo(startX + 23, startY + 23);
                    ctx.stroke();
                    ctx.closePath();

                    ctx.beginPath();
                    ctx.setLineDash([]);
                    ctx.moveTo(startX + 1, startY + 23);
                    ctx.lineTo(startX + 23, startY + 23);
                    ctx.lineTo(startX + 23, startY + 1);
                    ctx.lineTo(startX + 1, startY + 23);
                    ctx.fillStyle = isDarkTheme ? "#1f1f1f" : "rgb(255, 255, 255)";
                    ctx.fill();
                    ctx.closePath();

                    // ctx.beginPath()
                    // ctx.moveTo(startX+1, startY+1)
                    // ctx.lineTo(startX+22, startY+1)
                    // ctx.moveTo(startX+1, startY+22)
                    // ctx.lineTo(startX+1, startY+1)
                    // ctx.stroke()
                    // ctx.closePath()
                }
            } else {
                let rate = Math.min((width - offsetW) / (m_paperWidth * m_hSheet), (height - offsetH) / (m_paperHeight * m_vSheet));
                let tw = m_paperWidth * rate;
                let th = m_paperHeight * rate;
                let pw = m_pageWidth * rate;
                let ph = m_pageHeight * rate;

                let tpw, tph;
                if (tw * m_hSheet >= pw && th * m_vSheet >= ph) {
                    if ((tw * m_hSheet) / pw < (th * m_vSheet) / ph) {
                        tpw = tw * m_hSheet;
                        tph = (ph * tw * m_hSheet) / pw;
                    } else {
                        tpw = (pw * th * m_vSheet) / ph;
                        tph = th * m_vSheet;
                    }
                } else if (tw * m_hSheet >= pw && th * m_vSheet < ph) {
                    tpw = (pw * ph * m_vSheet) / ph;
                    tph = th * m_vSheet;
                } else if (tw * m_hSheet < pw && th * m_vSheet >= ph) {
                    tpw = tw * m_hSheet;
                    tph = (ph * tw * m_hSheet) / pw;
                } else {
                    if ((pw / tw) * m_hSheet < (ph / th) * m_vSheet) {
                        tpw = (pw * th * m_vSheet) / ph;
                        tph = th * m_vSheet;
                    } else {
                        tpw = tw * m_hSheet;
                        tph = (ph * tw * m_hSheet) / pw;
                    }
                }

                let sw = tw * m_hSheet;
                let sh = th * m_vSheet;

                let startX = Math.round((width - sw) * 0.5);
                let startY = Math.round((height - sh) * 0.5);

                if (Math.abs(sw - tpw) > 3 || Math.abs(sh - tph) > 3) {
                    ctx.fillStyle = isDarkTheme ? "#1f1f1f" : "rgb(255, 255, 255)";
                    ctx.fillRect(startX, startY, sw, sh);
                    ctx.stroke();
                    let edpaint = new EDPaint();
                    let edcolor = new EDColor();
                    edcolor._color = 0x3498db;
                    let edcolor2 = new EDColor();
                    edcolor2._color = 0xffffff;
                    edpaint._colors = [edcolor, edcolor2];
                    edpaint._index = 12;
                    edpaint._type = ePaintType.Hatch;
                    let path = new egRect(startX, startY, sw, sh).toPath();
                    edpaint.draw(ctx, null, null, null, false, path);
                }
                ctx.beginPath();
                ctx.strokeStyle = "rgb(160, 160, 160)";
                ctx.fillStyle = isDarkTheme ? "#1f1f1f" : "rgb(255, 255, 255)";
                ctx.rect(startX, startY, tpw, tph);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();

                ctx.strokeStyle = "rgb(160, 160, 160)";
                if (m_hSheet > 1 || m_vSheet > 1) {
                    for (let i = 1; i < m_hSheet; i++) {
                        if (i * tw - tpw > 1) {
                            ctx.beginPath();
                            ctx.moveTo(startX + i * tw, startY + 1);
                            ctx.lineTo(startX + i * tw, startY + sh - 1);
                            ctx.stroke();
                            ctx.closePath();
                        }
                    }
                    for (let i = 1; i < m_vSheet; i++) {
                        if (i * th - tph > 1) {
                            ctx.beginPath();
                            ctx.moveTo(startX + 1, startY + i * th);
                            ctx.lineTo(startX + sw - 1, startY + i * th);
                            ctx.stroke();
                            ctx.closePath();
                        }
                    }
                    if (sw - tpw > 1) {
                        for (let i = 1; i < m_vSheet; i++) {
                            ctx.beginPath();
                            ctx.moveTo(startX + tpw + 1, startY + i * th);
                            ctx.lineTo(startX + sw - 1, startY + i * th);
                            ctx.stroke();
                            ctx.closePath();
                        }
                    } else if (sh - tph > 1) {
                        for (let j = 1; j < m_hSheet; j++) {
                            ctx.beginPath();
                            ctx.moveTo(startX + j * tw, startY + tph + 1);
                            ctx.lineTo(startX + j * tw, startY + sh - 1);
                            ctx.stroke();
                            ctx.closePath();
                        }
                    }
                }
                ctx.setLineDash([5, 5]);
                ctx.fillStyle = "rgb(160, 160, 160)";
                if (tpw > tw || tph > th) {
                    for (let i = 1; i < m_hSheet; i++) {
                        if (tpw > i * tw + 1) {
                            ctx.beginPath();
                            ctx.moveTo(startX + i * tw, startY + 1);
                            ctx.lineTo(startX + i * tw, startY + tph - 1);
                            ctx.stroke();
                            ctx.closePath();
                        }
                    }
                    for (let j = 1; j < m_vSheet; j++) {
                        if (tph > j * th + 1) {
                            ctx.beginPath();
                            ctx.moveTo(startX + 1, startY + j * th);
                            ctx.lineTo(startX + tpw - 1, startY + j * th);
                            ctx.stroke();
                            ctx.closePath();
                        }
                    }
                }
                if (Math.abs(sw - tpw) <= 3 && Math.abs(sh - tph) <= 3) {
                    let edpaint = new EDPaint();
                    let edcolor = new EDColor();
                    edcolor._color = 0x3498db;
                    let edcolor2 = new EDColor();
                    edcolor2._color = 0xffffff;
                    edpaint._colors = [edcolor, edcolor2];
                    edpaint._index = 12;
                    edpaint._type = ePaintType.Hatch;
                    let path = new egRect(startX + tpw - 23, startY + 1, 22, 22).toPath();
                    edpaint.draw(ctx, null, null, null, false, path);

                    ctx.beginPath();
                    ctx.setLineDash([5, 5]);
                    ctx.fillStyle = "rgb(160, 160, 160)";
                    ctx.moveTo(startX + tpw - 23, startY + 1);
                    ctx.lineTo(startX + tpw, startY + 23);
                    ctx.stroke();
                    ctx.closePath();

                    ctx.beginPath();
                    ctx.setLineDash([]);
                    ctx.moveTo(startX + tpw - 23, startY + 1);
                    ctx.lineTo(startX + tpw - 23, startY + 23);
                    ctx.moveTo(startX + tpw - 23, startY + 23);
                    ctx.lineTo(startX + tpw, startY + 23);
                    ctx.stroke();
                    ctx.closePath();

                    ctx.beginPath();
                    ctx.setLineDash([]);
                    ctx.fillStyle = isDarkTheme ? "#1f1f1f" : "rgb(255, 255, 255)";
                    ctx.moveTo(startX + tpw - 23, startY + 1);
                    ctx.lineTo(startX + tpw - 23, startY + 23);
                    ctx.lineTo(startX + tpw - 23, startY + 23);
                    ctx.lineTo(startX + tpw, startY + 23);
                    ctx.fill();
                    ctx.closePath();

                    ctx.beginPath();
                    ctx.moveTo(startX + tpw - 22, startY + 1);
                    ctx.lineTo(startX + tpw - 1, startY + 1);
                    // ctx.moveTo(startX+tpw-1, startY+22)
                    // ctx.lineTo(startX+tpw-22, startY+1)
                    ctx.stroke();
                    ctx.fill();
                    ctx.closePath();
                }
            }
        }

        get pUnit() {
            return this.$store.state.page.pageUnit;
        }

        setpaper() {
            let printConfig = this.pageList[this.activePage]._printConfig;
            let size = 6;
            let format = "landscape";
            let printList = [];
            let fitList = "fit_1";
            let scale = 1;
            let pageWidth = UnitUtil.unitToPixel(printConfig._paperHeight, printConfig._paperUnit);
            let pageHeight = UnitUtil.unitToPixel(printConfig._paperWidth, printConfig._paperUnit);
            if (this.pageList[this.activePage]._isPortrait) {
                format = "portrait";
                pageWidth = UnitUtil.unitToPixel(printConfig._paperWidth, printConfig._paperUnit);
                pageHeight = UnitUtil.unitToPixel(printConfig._paperHeight, printConfig._paperUnit);
            }

            this.preDefinedPaper = s_prePapers[this.pageList[this.activePage]._preDefinedPaper];
            if (this.pageList[this.activePage]._preDefinedPaper == -1) {
                this.preDefinedPaper =
                    this.pageList[this.activePage]._unitWidth + " x " + this.pageList[this.activePage]._unitHeight + eUnit[this.pUnit + 9];
            }
            // console.log(this.pageList[this.activePage]._preDefinedPaper, this.pUnit+9);

            this.sizeList.forEach((item) => {
                if (printConfig._paperWidth == item.width && printConfig._paperHeight == item.height && printConfig._paperUnit == item.unit) {
                    size = item.value;
                }
            });

            if (printConfig._grid) {
                printList.push("grid");
            }
            if (printConfig._guideLine) {
                printList.push("guide");
            }
            if (printConfig._note) {
                printList.push("note");
            }
            if (printConfig._centered) {
                printList.push("Centered");
            }
            if (printConfig._fitTo) {
                fitList = "fit_2";
            }
            if (this.showWatermark) {
                printList.push("watermark");
            }
            this.$nextTick(() => {
                this.size = size;
                this.format = format;
                this.printList = printList;
                this.fitList = fitList;
                this.scale = printConfig._adjustPer;
                this.xSheet = printConfig._xSheet;
                this.ySheet = printConfig._ySheet;
                this.pageWidth = pageWidth;
                this.pageHeight = pageHeight;
            });
        }

        getMarginTop() {
            let item = this.pageList[this.activePage];
            if (!item?.canvasList) return 0;
            let container = document.querySelector(".print-content");
            if (!container) return 0;
            let marginTop = container.clientHeight - ((this.pageHeight * this.zoomValue) / 100 + 30) * item.canvasList.length;
            if (this.viewFitType == 2 || this.viewFitType == 3) {
                let row = Math.ceil(Math.sqrt(item.canvasList.length));
                let col = Math.ceil(item.canvasList.length / row);
                marginTop = container.clientHeight - ((this.pageHeight * this.zoomValue) / 100 + 30) * col;
            }

            if (marginTop > 0) {
                return marginTop / 2 + "px";
            }
            return 0;
        }

        getWrapperWidth() {
            let item = this.pageList[this.activePage];
            if (!item?.canvasList) return 0;
            if (this.viewFitType != 1) {
                let row = Math.ceil(Math.sqrt(item.canvasList.length));
                return ((this.pageWidth * this.zoomValue) / 100 + 30) * row + "px";
            } else {
                return (this.pageWidth * this.zoomValue) / 100 + 30 + "px";
            }
        }

        getWrapperHeight() {
            let item = this.pageList[this.activePage];
            if (!item?.canvasList) return 0;
            if (this.viewFitType != 1) {
                let row = Math.ceil(Math.sqrt(item.canvasList.length));
                let col = Math.ceil(item.canvasList.length / row);
                return ((this.pageHeight * this.zoomValue) / 100 + 30) * col + "px";
            } else {
                return ((this.pageHeight * this.zoomValue) / 100 + 30) * item.canvasList.length + "px";
            }
        }

        drawPreview() {
            let item = this.pageList[this.activePage];
            let pw, ph;
            let ncol = 1,
                nrow = 1;
            let calcSheet = item.calcPrintSheet(nrow, ncol, pw, ph);
            let dpScale = calcSheet.scale;
            ncol = calcSheet.col;
            nrow = calcSheet.row;
            pw = calcSheet.pw;
            ph = calcSheet.ph;
            let count = ncol * nrow;

            window["_view"].printPreviewText();
            let xScale = 1; // canvas.width / pw
            let yScale = 1; // canvas.height / ph

            let ix = 0,
                row = 1,
                col = 1;
            let canvasList = [];
            for (let i = 0; i < count; i++) {
                canvasList.push(i);
            }
            item.canvasList = canvasList;
            this.$nextTick(() => {
                while (ix < count) {
                    let c = <HTMLCanvasElement>this.$refs["printCanvas_" + item._id + "_" + ix];
                    let canvas = <HTMLCanvasElement>this.$refs["printCanvas_" + item._id + "_" + ix][0];
                    let ctx = canvas.getContext("2d");
                    canvas.width = this.pageWidth;
                    canvas.height = this.pageHeight;
                    ctx.fillStyle = this.isDarkTheme() ? "#1f1f1f" : "#fff";
                    ctx.fillRect(0, 0, this.pageWidth, this.pageHeight);
                    ctx.translate(0.5, 0.5);
                    row = Math.floor(ix / ncol);
                    col = ix - row * ncol;
                    let drawflag = eDrawFlag.IgnoreDpi | eDrawFlag.DrawingScale;
                    if (!this.printList.includes("grid")) {
                        drawflag |= eDrawFlag.HideGrid;
                    }
                    if (!this.printList.includes("guide")) {
                        drawflag |= eDrawFlag.HideGuideLine;
                    }

                    if (this.scale == 100) {
                        drawflag |= eDrawFlag.IgnoreZoom;
                    }
                    // item.updateDZMat(drawflag);
                    ctx.save();
                    item.drawBackground(ctx, eDrawFlag.Print | drawflag);
                    ctx.restore();
                    item.drawPrint(ctx, row, col, dpScale, nrow, ncol);
                    ix++;
                    this.showWatermark && ExportWaterMark.addWaterMark2(ctx, this.pageWidth, this.pageHeight, this.lang);
                }
            });

            // item.drawPrint(ctx, 0, 0, this.scale / 100);
        }

        pageSelectAll() {
            let list = [];
            this.pageList.forEach((item) => {
                list.push(item._id);
            });
            if (this.page.length !== this.pageList.length + 1) {
                this.page = list;
            } else {
                this.page = [];
            }
        }

        pageClearAll() {
            this.page = [];
        }

        pageSize() {
            let item = this.sizeList[this.size];
            let printConfig = this.pageList[this.activePage]._printConfig;
            printConfig._paperWidth = item.width;
            printConfig._paperHeight = item.height;
            printConfig._paperUnit = item.unit;
            let doc = window["_view"]._doc;
            if (this.format == "landscape") {
                this.pageWidth = UnitUtil.unitToPixel(item.height, item.unit);
                this.pageHeight = UnitUtil.unitToPixel(item.width, item.unit);
            } else {
                this.pageWidth = UnitUtil.unitToPixel(item.width, item.unit);
                this.pageHeight = UnitUtil.unitToPixel(item.height, item.unit);
            }
            this.drawPreview();
            this.viewFit(this.viewFitType);
            this.drawPrintView();
            this.sensors.track("printSettings", {
                Catalogues: "Print",
            });
        }

        pageFormat() {
            let item = this.pageList[this.activePage];
            let pageSize = this.sizeList[this.size];
            if (this.format == "landscape") {
                window["_view"].setPortrait(false);
                item._isPortrait = false;
                this.$store.commit("setPageStat", {
                    type: "isPortrait",
                    data: false,
                });
                this.pageWidth = UnitUtil.unitToPixel(pageSize.height, pageSize.unit);
                this.pageHeight = UnitUtil.unitToPixel(pageSize.width, pageSize.unit);
            } else {
                window["_view"].setPortrait(true);
                item._isPortrait = true;
                this.$store.commit("setPageStat", {
                    type: "isPortrait",
                    data: true,
                });
                this.pageWidth = UnitUtil.unitToPixel(pageSize.width, pageSize.unit);
                this.pageHeight = UnitUtil.unitToPixel(pageSize.height, pageSize.unit);
            }
            this.drawPreview();
            this.viewFit(this.viewFitType);
            this.drawPrintView();
            // window['_view'].page.outline2(eOutlineFlag.Text | eOutlineFlag.IgnNoExtend | eOutlineFlag.Background);
            this.sensors.track("printSettings", {
                Catalogues: "Print",
            });
        }

        pageScale() {
            let printConfig = this.pageList[this.activePage]._printConfig;
            printConfig._adjustPer = this.scale;
            this.drawPreview();
            this.viewFit(this.viewFitType);
            this.drawPrintView();
            this.sensors.track("printSettings", {
                Catalogues: "Print",
            });
        }

        showGrid() {
            let printConfig = this.pageList[this.activePage]._printConfig;

            if (this.printList.includes("grid")) {
                printConfig._grid = true;
            } else {
                printConfig._grid = false;
            }
            if (this.printList.includes("guide")) {
                printConfig._guideLine = true;
            } else {
                printConfig._guideLine = false;
            }
            if (this.printList.includes("note")) {
                printConfig._note = true;
            } else {
                printConfig._note = false;
            }
            if (this.printList.includes("Centered")) {
                printConfig._centered = true;
            } else {
                printConfig._centered = false;
            }
            if (this.printList.includes("watermark")) {
                this.showWatermark = true;
            } else {
                this.showWatermark = false;
            }
            this.drawPreview();
            this.sensors.track("printSettings", {
                Catalogues: "Print",
            });
        }

        fitChange() {
            let printConfig = this.pageList[this.activePage]._printConfig;
            if (this.fitList == "fit_1") {
                printConfig._fitTo = false;
            } else {
                printConfig._fitTo = true;
            }
            this.drawPreview();
            this.viewFit(this.viewFitType);
            this.drawPrintView();
            this.sensors.track("printSettings", {
                Catalogues: "Print",
            });
        }

        xsheetChange() {
            let printConfig = this.pageList[this.activePage]._printConfig;
            printConfig._xSheet = this.xSheet;
            this.drawPreview();
            this.viewFit(this.viewFitType);
            this.drawPrintView();
            this.sensors.track("printSettings", {
                Catalogues: "Print",
            });
        }

        xsheetBlur() {
            if (!this.xSheet) {
                this.xSheet = 1;
                let printConfig = this.pageList[this.activePage]._printConfig;
                printConfig._xSheet = this.xSheet;
                this.drawPreview();
                this.viewFit(this.viewFitType);
                this.drawPrintView();
            }
        }

        ysheetChange() {
            let printConfig = this.pageList[this.activePage]._printConfig;
            printConfig._ySheet = this.ySheet;
            this.drawPreview();
            this.viewFit(this.viewFitType);
            this.drawPrintView();
            this.sensors.track("printSettings", {
                Catalogues: "Print",
            });
        }

        ysheetBlur() {
            if (!this.ySheet) {
                this.ySheet = 1;
                let printConfig = this.pageList[this.activePage]._printConfig;
                printConfig._ySheet = this.ySheet;
                this.drawPreview();
                this.viewFit(this.viewFitType);
                this.drawPrintView();
            }
        }
        inputRange() {
            let target = this.$refs.zoomInput as HTMLInputElement;
            const min = parseInt(target.min);
            const max = parseInt(target.max);
            const val = parseInt(target.value);
            target.style.backgroundSize = ((val - min) * 100) / (max - min) + "% 100%";
        }
        zoomChange(e) {
            this.drawPreview();
        }

        pageChange() {
            if (this.page.includes("all")) {
                this.pageSelectAll();
            }
            this.sensors.track("printSettings", {
                Catalogues: "Print",
            });
        }

        viewFit(type) {
            if (!type) return;
            let item = this.pageList[this.activePage];
            this.viewFitType = type;
            let printContent = document.querySelector(".print-content");
            let itemWrapper = <HTMLElement>document.querySelector(".print-page-item-wrapper");
            let rateW = (printContent.clientWidth - 60) / this.pageWidth;
            let rateH = (printContent.clientHeight - 60) / this.pageHeight;
            if (type == 1) {
                if (rateW < rateH) {
                    this.zoomValue = Math.floor(rateW * 100);
                } else {
                    this.zoomValue = Math.floor(rateH * 100);
                }
            } else if (type == 4) {
                let row = Math.ceil(Math.sqrt(item.canvasList.length));
                let canvasW = (printContent.clientWidth - 60) / row - 30;
                rateW = canvasW / this.pageWidth;
                this.zoomValue = Math.floor(rateW * 100);
            } else if (type == 2 || type == 3) {
                let row = Math.ceil(Math.sqrt(item.canvasList.length));
                let canvasW = (printContent.clientWidth - 60) / row - 30;
                let canvasH = (printContent.clientHeight - 60) / Math.ceil(item.canvasList.length / row) - 30;
                rateW = canvasW / this.pageWidth;
                rateH = canvasH / this.pageHeight;
                if (rateW < rateH) {
                    this.zoomValue = Math.floor(rateW * 100);
                } else {
                    this.zoomValue = Math.floor(rateH * 100);
                }
            }
        }

        zoomDowns() {
            if (this.zoomValue > 15) {
                this.zoomValue -= 5;
                this.drawPreview();
            } else {
                this.zoomValue = 10;
                this.drawPreview();
            }
            this.inputRange();
        }

        zoomUps() {
            if (this.zoomValue < 195) {
                this.zoomValue = +this.zoomValue + 5;
                this.drawPreview();
            } else {
                this.zoomValue = 200;
                this.drawPreview();
            }
            this.inputRange();
        }

        pagePre() {
            if (this.activePage > 0) {
                this.activePage--;
                this.setpaper();
                this.$nextTick(() => {
                    this.drawPreview();
                    this.viewFit(this.viewFitType);
                    this.drawPrintView();
                });
            }
        }

        pageNext() {
            if (this.activePage < this.pageList.length - 1) {
                this.activePage++;
                this.setpaper();
                this.$nextTick(() => {
                    this.drawPreview();
                    this.viewFit(this.viewFitType);
                    this.drawPrintView();
                });
            }
        }

        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        // 用户偏好
        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }

        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }

        setPrintWaterMarkCustomPrefer() {
            let data = this.customPreferContent || {};
            if (data["defaultIsShowWatermark"] === this.showWatermark) return;
            Object.assign(data, { defaultIsShowWatermark: this.showWatermark });
            this.customPreferContent = data;
            let jsonStr = JSON.stringify(data);
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                obj: { content: jsonStr },
            };
            this.$edApi.updateUserPrefer(params);
        }

        print() {
            if (this.checkVipLimit("printFile")) {
                return;
            }
            let ts: any = this;
            ts.setPrintWaterMarkCustomPrefer();
            if (!ts.vip && !this.showWatermark) {
                ts.$openBuyPage("printNomark");
                return;
            }
            this.sensors.track("clickPrint", {
                Catalogues: "Print",
            });
            import("@/app/utils/pdfDep.js").then((blobStream) => {
                let w = this.pageWidth;
                let h = this.pageHeight;
                let pW = UnitUtil.pixelToUnit(w, eUnit.pt);
                let pH = UnitUtil.pixelToUnit(h, eUnit.pt);
                var doc = new PDFDocument({ layout: "landscape", size: [pH, pW], margin: 0 });
                let bs: any = blobStream.default;
                var stream = doc.pipe(bs());

                for (let i = 0; i < ts.page.length; i++) {
                    ts.pageList.forEach((item) => {
                        if (item._id == this.page[i]) {
                            item.canvasList.forEach((index) => {
                                let canvas = <HTMLCanvasElement>this.$refs["printCanvas_" + item._id + "_" + index][0];
                                // doc.layout = 'landscape'
                                // w = UnitUtil.unitToPixel(item._printConfig._paperHeight, item._printConfig._paperUnit);
                                // h = UnitUtil.unitToPixel(item._printConfig._paperWidth, item._printConfig._paperUnit);
                                // if (item._isPortrait) {
                                //     w = UnitUtil.unitToPixel(item._printConfig._paperWidth, item._printConfig._paperUnit);
                                //     h = UnitUtil.unitToPixel(item._printConfig._paperHeight, item._printConfig._paperUnit);
                                //     doc.layout = 'portrait'
                                // }
                                // pW = UnitUtil.pixelToUnit(w, eUnit.pt);
                                // pH = UnitUtil.pixelToUnit(h, eUnit.pt);
                                // console.log(pW, pH);

                                // doc.size = [pH, pW]
                                if (i == 0 && index == 0) {
                                    doc.image(canvas.toDataURL(), 0, 0, { width: pW, height: pH });
                                } else {
                                    doc.addPage().image(canvas.toDataURL(), 0, 0, { width: pW, height: pH });
                                }
                            });
                        }
                    });
                }
                var ref = doc.ref({
                    Type: "Action",
                    S: "Named",
                    N: "Print",
                });

                doc._root.data.OpenAction = ref;
                ref.end();

                doc.end();
                stream.on("finish", () => {
                    let blob = stream.toBlobURL("application/pdf");
                    window["_view"]._printFrame.src = blob;
                    this.sensors.track("printSuccess", {
                        Catalogues: "Print",
                    });
                });
            });
        }

        close() {
            this.$store.commit("setStatus", {
                type: "showPrintContainer",
                data: false,
            });
        }
    }
</script>
